module.exports = __webpack_public_path__ + "img/logo.a4d89875.webp";